import { html, LitElement } from "lit-element";
import {localize} from "@stofloos/actions/localize";
import {connect} from "pwa-helpers/connect-mixin.js";
import {store} from "@stofloos/stores/store";

export class StofwareBreadcrumb extends connect(store)(LitElement) {
    static get properties() {
        return {
            // Title for last element in breadcrumb
            title: {type: String },
            showHome: {type: Boolean},
            skipView: {type: Boolean},
            seperator: {type: String},
            pathArray: {type: Array}
        };
    }

    constructor() {
        super();
        this.showHome = true;
        this.skipView = true;
        this.seperator = "> ";
        const path = window.decodeURIComponent(location.pathname);
        const splitPath = (path || "").slice(1).split("/");
        if(this.skipView) {
            splitPath.splice(1, 1);
        }
        this.pathArray = splitPath;
    }

    stateChanged(state) {
        if(this.pathArray !== state.app.pathArray) {
            this.pathArray = state.app.pathArray;
        }
    }

    render() {
        // language=HTML
        return html`
			<style>
				a {
                    text-decoration: none;
                    color: var(--app-primary);
                }
                .breadcrumb {
                    font-size: 13px;
                    opacity: 0.57;
                }
			</style>
            <div class="breadcrumb layout horizontal">
                ${this.showHome ? html`<a href="/">Home</a><span style="margin: 0 5px;">${this.seperator}</span>` : ``}
                
                ${this.pathArray && this.pathArray.map((item, index) => {
                    let translation;
                    if(index === this.pathArray.length-1 && this.title) {
                        // use title if present
                        translation = this.title;
                    } else if(index === 0) {
                        const count = this.pathArray.length > 1 ? 1 : 2;
                        translation = localize("models::"+item, {count:count});
                    } else if(index === 1 ) {
                        translation = localize("main::"+item);
                    } else {
                        translation = localize(item);
                    }
                    return html`
                        <a style="text-transform: capitalize" href="${this.pathArray.slice(0, index+1).join("/")}">${translation}</a>
                            ${this.pathArray.length - 1 !== index ? html`
                                <span style="margin: 0 5px;">${this.seperator}</span>
                            `: ``}
                        `
                })}
            </div>
		`;
    }
}

window.customElements.define("sw-breadcrumb", StofwareBreadcrumb);
